// extracted by mini-css-extract-plugin
export default {"dark":"styles_dark__rY7vN","container":"styles_container__uqeWm","title":"styles_title__b-6gG","content":"styles_content__CUO4j","appPlay":"styles_appPlay__uOnwc"};